import { render } from "./shopInfo.vue?vue&type=template&id=d2381c96&scoped=true"
import script from "./shopInfo.vue?vue&type=script&lang=js"
export * from "./shopInfo.vue?vue&type=script&lang=js"

import "./shopInfo.vue?vue&type=style&index=0&id=d2381c96&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2381c96"]])

export default __exports__